import React, { useEffect, useState, useRef } from "react";
import InView from "react-intersection-observer";
import Slider from 'react-slick';
import CPImage1 from "../../images/pod-intro-img-1.png";
import CPImage2 from "../../images/pod-intro-img-2.png";
import CPImage3 from "../../images/pod-intro-img-3.png";

import CPImage1Mobile from "../../images/pod-intro-img-mobile-1.png";
import CPImage2Mobile from "../../images/pod-intro-img-mobile-2.png";
import CPImage3Mobile from "../../images/pod-intro-img-mobile-3.png";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import { motion } from 'framer-motion';
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";

export default function Intro() {
  const [isMobile, setisMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const setValues = () => {
    setisMobile(window.innerWidth <= 767);
  };

  useEffect(() => {
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });


  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    autoplay: true,
    fade: true,
    speed: 1000,
    cssEase: 'linear',
    adaptiveHeight: true
  };

  return (
    <InView onChange={(inView) => setIsVisible(inView)}>
      <div className="cs-intro-section section-gap pod-cs-intro-section" onLoad={setValues}>
        <div className="pod-cs-intro-top section-gap-large">
          <div className="container">
            <div className="intro-inner">
              <h2 className="theme-color-title">{isVisible ? <HeaderAnim header="TRANSFORMING SUPPLY-CHAIN" /> : ""}</h2>
              <h3 className="h3">The ‘last mile’ challenge</h3>
              <p>Our client is one of America's largest manufacturers and distributors of commercial hardware products with 40+  distribution and corporate facilities across the nation. Besides, they are growing and expanding through multiple focused acquisitions.</p>

              <p>With thousands of deliveries each day, the client had the challenge of tracking and sorting physical copies of delivery documents from the delivery, quality assurance, and production units. The process involved storing, processing, and forwarding many physical documents such as waybills and delivery receipts across all decentralized locations. Relying on their complex paper-based process, particularly when the key documents become misplaced, overlooked, or lost due to manual work, resulted in a bad customer experience, higher costs of delivery, and sometimes loss of revenue.</p>
            </div>
          </div>
        </div>
        <div className="pod-cs-intro-middle section-gap">
          <div className="workfow-img-wrapper">
            {isMobile && <>  <Slider {...settings}>
              <img src={CPImage1Mobile} title="last mile challenge" alt="last mile challenge" />
              <img src={CPImage2Mobile} title="last mile challenge" alt="last mile challenge" />
              <img src={CPImage3Mobile} title="last mile challenge" alt="last mile challenge" />
            </Slider></>}
            {!isMobile && <>
              <Parallax id="last-mile-challenge-plan" length={100} direction={directions.BTT} triggers={[0.9, 0.7]} opacity={true}>
                <motion.img src={CPImage1} title="plan" alt="plan" />
              </Parallax>
              <Parallax id="last-mile-challenge-dispatch" length={100} direction={directions.BTT} triggers={[0.9, 0.7]} opacity={true}>
                <motion.img src={CPImage2} title="dispatch" alt="dispatch" />
              </Parallax>
              <Parallax id="last-mile-challenge-deliver" length={100} direction={directions.BTT} triggers={[1, 0.7]} opacity={true}>
                <motion.img src={CPImage3} title="deliver" alt="deliver" />
              </Parallax>
            </>}
          </div>
        </div>
        <div className="pod-cs-intro-bottom">
          <div className="container-small">
            <div className="intro-inner">
              <h4 className="h4">Digitizing the delivery experience</h4>
              <p>To improve customer experiences and optimize delivery costs, the client recognized the need to rethink their entire doorstep delivery process. They also needed to reshape the way dispatching, proof-of-delivery, delivery rescheduling, and product returns are handled. They partnered with Rapidops to transform and digitize the end-to-end last-mile delivery operations, including loading, dispatch planning, fleet management, real-time monitoring, and proof of delivery. </p>
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
}